import LoginMessage from './LoginMessage';

export default LoginMessage;
